import { FC, useEffect } from 'react';
// Redux
import { getLiveScreen, resetLiveScreen } from 'redux/dashboard-service/action';
// Components
import { LiveScreenForm } from './LiveScreenForm';
import { LiveScreenSettings } from './LiveScreenSettings';
import useThunkDispatch from '../../../core/customHooks/useThunkDispatch';

export enum LiveScreenTab {
	Preview = 'preview',
	Settings = 'settings',
}

type LiveScreenProps = {
	activeTab?: LiveScreenTab;
};

export const LiveScreen: FC<LiveScreenProps> = ({ activeTab = LiveScreenTab.Preview }) => {
	const dispatch = useThunkDispatch();

	useEffect(() => {
		dispatch(getLiveScreen());

		return () => {
			dispatch(resetLiveScreen());
		};
	}, [dispatch]);

	if (activeTab === LiveScreenTab.Settings) {
		return <LiveScreenSettings />;
	}

	return <LiveScreenForm />;
};
